import { lazyLoadObserve } from "./lazyLoad";

const imageLoop = document.querySelector('.js-image-loop');

if (imageLoop) {
  const images = [...imageLoop.querySelectorAll('.js-image-loop > *')];
  if (imageLoop.scrollWidth > window.innerWidth) {
    [...images].forEach((image) => {
      const prevClone = image.cloneNode(true);
      imageLoop.insertBefore(prevClone, images[0]);
      imageLoop.appendChild(image.cloneNode(true));
    });
    imageLoop.classList.add("slide");
    lazyLoadObserve().observe();
  }
}